<template>
  <b-modal
    id="equipamentos-modal"
    ref="equipamentosModal"
    title="Lista de Equipamentos"
    hide-footer
  >
    <b-list-group>
      <b-list-group-item
        v-for="equipamento in equipamentos"
        :key="equipamento.id"
        class="d-flex justify-content-between align-items-right"
      >
        <b-form
          class="mr-2"
        >
          {{ equipamento.name }}
        </b-form>
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
/* eslint-disable */
import { request } from '@/services'; // ajuste se necessário
import { DB_ROUTES } from '../../constants';

export default {
  name: 'EquipamentosModal',
  props: {
    equipamentos: {
      type: Array,
      required: true,
    },
    empresa: {
      type: Object, // Corrigido para Object, pois no pai é empresaSelecionada (um objeto)
      required: true,
    },
  },
  data() {
    return {
      selectedEquipamentos: [],
    };
  },
  watch: {
    empresa: {
      immediate: true,
      handler(novaEmpresa) {
        if (novaEmpresa && novaEmpresa.id) {
          this.carregarEquipamentos(novaEmpresa.id);
        }
      },
    },
  },
  methods: {
    show() {
      this.$refs.equipamentosModal.show();
    },
    hide() {
      this.$refs.equipamentosModal.hide();
    },
    carregarEquipamentos(idEmpresa) { //Carregar equipamentos de determinada empresa
      request.get(
        DB_ROUTES.GET_EQUIPMENTS_BY_COMPANY(idEmpresa),
        response => {
          if (Array.isArray(response.data)) {
            this.selectedEquipamentos = response.data.map(e => e.name);
          } else {
            console.error('Resposta inesperada ao buscar equipamentos:', response);
            this.selectedEquipamentos = [];
          }
        },
        error => {
          // TODO: use error.response.status and display 
          // a message when the company has no equipments (404)
          console.error('Erro ao carregar equipamentos:', error);
          this.selectedEquipamentos = [];
        }
      );
    },
    atualizarEquipamento(equipamento) {
      const equipamentoIndex = this.selectedEquipamentos.indexOf(equipamento.name);
      const status = equipamentoIndex === -1;

      // Atualiza array local
      if (status) {
        this.selectedEquipamentos.push(equipamento.nome);
      } else {
        this.selectedEquipamentos.splice(equipamentoIndex, 1);
      }

      const payload = {
        id: equipamento.id,
        name: equipamento.name,
        equipmentIdentification: equipamento.equipmentIdentification,
        companyId: status ? this.empresa.id : null 
      };


      console.log('Payload enviado:', payload);

      request.put(
        DB_ROUTES.PUT_EQUIPMENT(equipamento.id),
        payload,
        (response) => {
          this.$bvToast.toast('Equipamento atualizado com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
          });
        },
        (error) => {
          this.$bvToast.toast('Erro ao atualizar equipamento.', {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          });
          console.error('Erro ao atualizar equipamento:', error);
        }
      );
    },
  },
};
</script>
